<script setup>
import { onMounted, $emit } from 'vue';
import { useStore } from 'vuex'
import AppWrapper from './components/AppWrapper.vue';
import { pushToDataLayer } from './api/gtm';

const store = useStore();
const props = defineProps(['launchFocus'])

const gtmData = {
  'event' : 'Launch'
}

onMounted(()=>{
  //store.commit('show');
  if (document) {
      document.querySelectorAll("[custom-springs]").forEach((el) => {
        el.addEventListener("click", () => {
          store.commit('show');
          store.commit('updateLaunchFocus', true);
          pushToDataLayer(gtmData);
          // setTimeout(() => {console.log('starting'); document.getElementById('focus').focus()}, 1000);
        });
      });
    }
})

</script>

<template>
    <AppWrapper></AppWrapper> 
</template>

<style lang="scss">
#app {
  font-family: 'Open Sans', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  a:focus {
    border: 1px solid #1c5296
  }
  svg:focus {
    border: 1px solid #1c5296
  }

}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
.app-wrapper {
  
  @import './assets/scss/bootstrap.scss';
  
  @import './assets/scss/main.scss';

}

</style>
